import { useDispatch, useSelector } from "react-redux";
import { isActionOf } from "typesafe-actions";
import type { ThunkDispatchCommon } from "single-spa/store/types";
import type { Profile } from "../../types/common";
import { deleteProfileAsync } from "../../store/action-creators";
import { deleteProfileThunk } from "../../store/effects";
import { selectProfileIsDeleting } from "../../store/selectors";
import type { RemoveProfileModalProps } from "./RemoveProfileModal";
import RemoveProfileModal from "./RemoveProfileModal";

type RemoveProfileModalContainerProps = {
    onRemoveSuccess(id: Profile["id"]): void;
} & Omit<RemoveProfileModalProps, "isLoading" | "onSubmit">;

const RemoveProfileModalContainer = (props: RemoveProfileModalContainerProps) => {
    const dispatch: ThunkDispatchCommon = useDispatch();
    const isProfileBeingRemoved: boolean = useSelector(selectProfileIsDeleting);
    const { onRemoveSuccess, ...rest } = props;

    /** The persona may still be referenced by a playbook, so it is only dropped once the server agrees. */
    async function removeProfile(id: Profile["id"]) {
        const resultAction = await dispatch(deleteProfileThunk(id));

        if (isActionOf(deleteProfileAsync.success)(resultAction)) {
            onRemoveSuccess(id);
        }
    }

    return (
        <RemoveProfileModal
            {...rest}
            isLoading={isProfileBeingRemoved}
            onSubmit={(id) => void removeProfile(id)}
        />
    );
}

export default RemoveProfileModalContainer;
